/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_List_SuccessInputs */

const es_tools_drive_list_success = /** @type {(inputs: Tools_Drive_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Carpeta de Drive listada`)
};

const en_tools_drive_list_success = /** @type {(inputs: Tools_Drive_List_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drive folder listed`)
};

/**
* | output |
* | --- |
* | "Drive folder listed" |
*
* @param {Tools_Drive_List_SuccessInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_list_success = /** @type {((inputs?: Tools_Drive_List_SuccessInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_List_SuccessInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_list_success(inputs)
	return en_tools_drive_list_success(inputs)
});
export { tools_drive_list_success as "tools.drive.list_success" }